export const API_BASE_URL = process.env.VITE_API_BASE_URL || 'http://localhost:8000';
export const API_VERSION = '/v1';
